// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';

import style from '../recepetion/components/Reception.scss';
import buttonStyle from '../../../assets/styles/button.scss';

import type { ShipmentItem } from '../../../entities';

type Props = {
  +orderId: string;
  +shipmentItem: ShipmentItem;
  +handleReceiveProduct: (orderId: string, orderItemNumber: number) => void;
  +isReceived: boolean;
};

export default class Item extends Component<Props> {
  render() {
    const {
      shipmentItem,
      handleReceiveProduct,
      orderId,
      isReceived,
    } = this.props;
    return (
      <tr className={classNames({[style.opacity]: isReceived})}>
        <td>
          <img className={style.image}
               src={shipmentItem.orderItem.image}
               alt={shipmentItem.orderItem.name}/>
          <p className={style.amount}>{shipmentItem.orderItem.amount}</p>
        </td>
        <td>
          <div className={style.orderInfo}>
            <a className={style.url}
               href={shipmentItem.orderItem.url}
               target="_blank"
               rel="noopener noreferrer nofollow">{shipmentItem.orderItem.name}</a>
            {!!shipmentItem.orderItem.tracking &&
            <Fragment>
              <FormattedMessage id="courier.reception.row.storeOrderId">{
                txt => <p className={style.propertyInfo}>
                  {txt}: <span>{shipmentItem.orderItem.tracking.storeOrderId}</span></p>
              }</FormattedMessage>
              <FormattedMessage id="courier.reception.row.trackingNumber">{
                txt => <p className={style.propertyInfo}>
                  {txt}: <span>{shipmentItem.orderItem.tracking.trackingNumber}</span></p>
              }</FormattedMessage>
            </Fragment>}
            {!!shipmentItem.orderItem.externalInvoice && shipmentItem.orderItem.externalInvoice.image &&
            <FormattedMessage id="courier.reception.row.seeInvoice">{
              txt => <a className={style.url}
                        href={shipmentItem.orderItem.externalInvoice.image}
                        target="_blank"
                        rel="noopener noreferrer nofollow">{txt}</a>
            }</FormattedMessage>}
            {isReceived  && 
            <h3 className={style.delivered}>
              Item entregado
            </h3>}
          </div>
        </td>
        <td>
          <div className={style.orderDetails}>
            <FormattedMessage id="courier.reception.row.unitPrice">{
              txt => <p className={style.propertyInfo}>
                {txt}: <span>$ {shipmentItem.orderItem.price}</span></p>
            }</FormattedMessage>
            {!!shipmentItem.orderItem.weight &&
            <FormattedMessage id="courier.reception.row.weight">{
              txt => <p className={style.propertyInfo}>
                {txt}: <span>{shipmentItem.orderItem.weight} kg</span></p>
            }</FormattedMessage>}
            <FormattedMessage id="courier.reception.row.category">{
              txt => <p className={style.propertyInfo}>
                {txt}: <span>{shipmentItem.orderItem.category.name}</span></p>
            }</FormattedMessage>
            <FormattedMessage id="courier.reception.row.packaging">{
              txt => <p className={style.propertyInfo}>
                {txt}: <FormattedMessage
                id={shipmentItem.orderItem.originalPackaging ? 'courier.reception.row.withBox' :
                  'courier.reception.row.withoutBox'}>{
                txt => <span>{txt}</span>}</FormattedMessage></p>
            }</FormattedMessage>
            {!!shipmentItem.orderItem.detail &&
            <Fragment>
              <FormattedMessage id="courier.reception.row.details">{
                txt => <p>{txt}: <span>{shipmentItem.orderItem.detail}</span></p>
              }</FormattedMessage>
            </Fragment>}
          </div>
        </td>
        <td>
          {shipmentItem.orderItem.state === 'PENDING' &&
          <FormattedMessage id="courier.reception.row.receiptButton">{
            txt => <button className={classNames(buttonStyle.btn, buttonStyle.lightBlue,
              style.receiptButton)}
                           onClick={() => handleReceiveProduct(orderId, shipmentItem.orderItem.orderItemId)}>
              {txt}</button>
          }</FormattedMessage>}
        </td>
      </tr>
    );
  }
}

Item.propTypes = {
  orderId: PropTypes.string.isRequired,
  shipmentItem: PropTypes.object.isRequired,
  handleReceiveProduct: PropTypes.func.isRequired,
  isReceived: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/courier/Item/Item.jsx